import { useDisclose, useLoader } from 'hooks/utilHooks';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ReactHtmlParser from 'react-html-parser';
import { PartnerService } from 'services';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  AppBar,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  LinearProgress,
  Link,
  Slide,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const PartnershipTerms: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclose();
  const [terms, setTerms] = useState('');
  const { hideLoader, showLoader, loading } = useLoader();
  const { setValue } = useFormContext();

  useEffect(() => {
    if (isOpen && !terms) {
      try {
        showLoader();
        PartnerService.getPartnershipTerms().then(setTerms);
      } catch (reason) {
        onClose();
      } finally {
        hideLoader();
      }
    }
  }, [hideLoader, isOpen, onClose, showLoader, terms]);

  return (
    <Grid item container xs={12} md={12} mt={4}>
      <Grid item xs={12} md={12}>
        <Controller
          name="acceptPartnershipTerms.isAccepted"
          render={({ field: { value, onBlur }, fieldState }) => {
            const hasError = Boolean(fieldState.error?.message);

            const handleChange = () => {
              setValue('acceptPartnershipTerms.isAccepted', !value, {
                shouldValidate: true,
              });
            };

            return (
              <FormControl
                component="fieldset"
                required={true}
                error={hasError}
              >
                <FormControlLabel
                  name="acceptPartnershipTerms.isAccepted"
                  label={
                    <Typography
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <Typography component="span" onClick={handleChange}>
                        {'Eu aceito e concordo com os '}
                      </Typography>

                      <Link onClick={onOpen} underline="hover">
                        Termos de parceria.
                      </Link>
                    </Typography>
                  }
                  labelPlacement="end"
                  checked={value}
                  value={value}
                  onBlur={onBlur}
                  onClick={(e) => {
                    e.preventDefault();

                    handleChange();
                  }}
                  control={<Checkbox />}
                />

                <FormHelperText>{fieldState.error?.message}</FormHelperText>
              </FormControl>
            );
          }}
        />
      </Grid>

      <Dialog
        fullScreen
        /* @ts-ignore */
        TransitionComponent={Transition}
        open={isOpen}
        onClose={onClose}
      >
        <AppBar sx={{ position: 'relative' }} elevation={0}>
          <Toolbar>
            <Tooltip title="Voltar">
              <IconButton
                edge="start"
                color="inherit"
                onClick={onClose}
                aria-label="close"
                sx={{ color: 'white' }}
              >
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>

            <Typography
              sx={{ ml: 2, flex: 1, color: 'white' }}
              variant="h6"
              component="div"
            >
              Termos de parceria
            </Typography>
          </Toolbar>

          {loading && <LinearProgress />}
        </AppBar>

        <Grid
          item
          container
          flex={1}
          lg={6}
          sm={10}
          mt={4}
          alignSelf="center"
          style={{
            height: '100%',
            overflow: 'scroll',
            overflowX: 'hidden',
            overflowY: 'scroll',
            flex: 1,
          }}
        >
          {ReactHtmlParser(terms)}
        </Grid>
      </Dialog>
    </Grid>
  );
};

